import { computed, Ref, ref } from 'vue';

export const modals = {
  NEW_USER: 'NEW_USER',
  CREATE_SINGLE_USER: 'CREATE_SINGLE_USER',
  CREATE_MULTIPLE_USERS: 'CREATE_MULTIPLE_USERS',
  EDIT_USER: 'EDIT_USER',
  MANAGE_USER_LOGIN_INFO: 'MANAGE_USER_LOGIN_INFO',
  CREATE_LOGIN_CARD: 'CREATE_LOGIN_CARD',
  CONFIRM_DELETE_USER: 'CONFIRM_DELETE_USER',
  CONFIRM_DELETE_USER_QR_CODE: 'CONFIRM_DELETE_USER_QR_CODE',
  EDIT_GROUP: 'EDIT_GROUP',
  EDIT_GROUP_LOGIN: 'EDIT_GROUP_LOGIN',
  CONFIRM_DELETE_GROUP_CODE: 'CONFIRM_DELETE_GROUP_CODE',
  CONFIRM_DELETE_GROUP_MEMBERSHIP: 'CONFIRM_DELETE_GROUP_MEMBERSHIP',
  SET_GROUP_PASSWORD: 'SET_GROUP_PASSWORD',
};

const isOpen: Ref<Record<string, boolean>> = ref({});
const useModal = (name: string) => {
  isOpen.value = { ...isOpen.value, [name]: false };

  const open = () => {
    isOpen.value = { ...isOpen.value, [name]: true };
  };

  const close = () => {
    isOpen.value = { ...isOpen.value, [name]: false };
  };

  return {
    isOpen: computed(() => isOpen.value[name] ?? false),
    open,
    close,
  };
};

export default useModal;
